import { render, staticRenderFns } from "./handle-quotation.vue?vue&type=template&id=2e38d2c3&scoped=true&"
import script from "./handle-quotation.vue?vue&type=script&lang=js&"
export * from "./handle-quotation.vue?vue&type=script&lang=js&"
import style0 from "./handle-quotation.vue?vue&type=style&index=0&id=2e38d2c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38d2c3",
  null
  
)

export default component.exports